export const ErrorMessage = ({ message }: { message: string }) => {
  return <span className="text-sm font-medium text-red-800">{message}</span>;
};
